import { Component, OnInit } from '@angular/core';

import { NgbModule, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { MiraieService } from '../Services/miraie.service';
import { StatusService } from '../Services/status.service';
import { AuthService } from '../Services/auth.service';
import { OutputService } from '../Services/output.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-goal-list',
  templateUrl: './goal-list.component.html',
  styleUrls: ['./goal-list.component.css']
})
export class GoalListComponent implements OnInit {
  years: number[] = [2018, 2017, 2016, 2015, 2014];
  months: any[] = [
    { month: 7, view: false, score: null, disabled: false },
    { month: 8, view: false, score: null, disabled: false },
    { month: 9, view: false, score: null, disabled: false },
    { month: 10, view: false, score: null, disabled: false },
    { month: 11, view: false, score: null, disabled: false },
    { month: 12, view: false, score: null, disabled: false },
    { month: 1, view: false, score: null, disabled: false },
    { month: 2, view: false, score: null, disabled: false },
    { month: 3, view: false, score: null, disabled: false },
    { month: 4, view: false, score: null, disabled: false },
    { month: 5, view: false, score: null, disabled: false },
    { month: 6, view: false, score: null, disabled: false },
  ];

  logininfo: Logininfo = this.authService.loginID;
  year: number;
  output_year: number;
  output_month: number;

  view;
  all_year = false;

  divilist: any[];
  srcurl: string;

  constructor(
    private miraieService: MiraieService,
    private statusService: StatusService,
    public authService: AuthService,
    private outputService: OutputService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.mkYears();
    this.srcurl = this.miraieService.srcurl;
    this.view = "all";
    this.year = new Date().getFullYear();
    var month = new Date().getMonth() + 1;
    if (month < 7) {
      this.year--;
    }
    //今月にチェック
    this.months.map(function (value) {
      if (value.month == month) {
        return value.view = true;
      }
    });
    this.changeRecord();
  }
  mkYears() {
    let min = 2018;
    let max = new Date().getFullYear();
    let m = new Date().getMonth() + 1;
    if (m < 7) {
      max--;
    }
    this.years = [];
    let year_list = [];
    for (let i = min; i <= max; i++) {
      year_list.push(i);
    }
    year_list.sort(function (a, b) {
      if (a > b) return -1;
      if (a < b) return 1;
      return 0;
    }
    );
    this.years = year_list;
  }

  //指定年度のレコードをDBから取得してくる
  changeRecord() {
    this.ListHide();
    this.statusService.getDivisionStatusList(null, this.year).subscribe(result => {
      this.createDivisionList(result);

      this.statusService.getPersonalStatusList(null, this.year).subscribe(result => {
        this.createUserList(result);
        // this.SearchRecord();
      });
    });
  }


  //選択した月のデータを抽出
  SearchRecord() {
    this.sumRecord();
  }
  //各月の合計を計算
  sumRecord() {
    this.divilist.forEach(divi => {
      let view = {
        new_actual: 0,
        new_target: 0,
        ap_actual: 0,
        ap_target: 0,
        app_result: 0,
        app_target: 0,
        contract_record: 0,
        contract_target: 0
      }
      this.months.forEach(month => {
        /*
        if (month.view && ((month.month - 1) in divi.result)) {
          view.new_actual += divi.result[month.month - 1].new_actual;
          view.new_target += divi.result[month.month - 1].new_target;
          view.ap_actual += divi.result[month.month - 1].ap_actual;
          view.ap_target += divi.result[month.month - 1].ap_target;
          view.app_result += divi.result[month.month - 1].app_result;
          view.app_target += divi.result[month.month - 1].app_target;
          view.contract_record += divi.result[month.month - 1].contract_record;
          view.contract_target += divi.result[month.month - 1].contract_target;
        }
        */
        if (month.view && (month.month in divi.result)) {
          view.new_actual += divi.result[month.month].new_actual;
          view.new_target += divi.result[month.month].new_target;
          view.ap_actual += divi.result[month.month].ap_actual;
          view.ap_target += divi.result[month.month].ap_target;
          view.app_result += divi.result[month.month].app_result;
          view.app_target += divi.result[month.month].app_target;
          view.contract_record += divi.result[month.month].contract_record;
          view.contract_target += divi.result[month.month].contract_target;
        }
    });
      divi.view = view;

      divi.user.forEach(user => {
        let viewUser = {
          new_actual: 0,
          new_target: 0,
          ap_actual: 0,
          ap_target: 0,
          app_result: 0,
          app_target: 0,
          contract_record: 0,
          contract_target: 0
        }
        this.months.forEach(month => {
          /*
          if (month.view && ((month.month - 1) in divi.result)) {
            viewUser.new_actual += user.result[month.month - 1].new_actual;
            viewUser.new_target += user.result[month.month - 1].new_target;
            viewUser.ap_actual += user.result[month.month - 1].ap_actual;
            viewUser.ap_target += user.result[month.month - 1].ap_target;
            viewUser.app_result += user.result[month.month - 1].app_result;
            viewUser.app_target += user.result[month.month - 1].app_target;
            viewUser.contract_record += user.result[month.month - 1].contract_record;
            viewUser.contract_target += user.result[month.month - 1].contract_target;
          }
          */
          if (month.view && (month.month in divi.result)) {
            viewUser.new_actual += user.result[month.month].new_actual;
            viewUser.new_target += user.result[month.month].new_target;
            viewUser.ap_actual += user.result[month.month].ap_actual;
            viewUser.ap_target += user.result[month.month].ap_target;
            viewUser.app_result += user.result[month.month].app_result;
            viewUser.app_target += user.result[month.month].app_target;
            viewUser.contract_record += user.result[month.month].contract_record;
            viewUser.contract_target += user.result[month.month].contract_target;
          }
        });
        user.view = Object.assign({}, viewUser);

      });
    })
  }


  //事業所別　予実リスト作成
  createDivisionList(result) {
    let temp = [];
    let all_temp = {
      code: null,
      name: '全体',
      result: [],
      view: [],
      user: [],
    };

    result.forEach(score => {
      let div_code = score.division_code;
      let div_name = score.division_name;
      if (!div_code) {
        div_code = 0;
        div_name = '全体'
      }
      if (!temp[div_code]) {
        temp[div_code] = {
          code: div_code,
          name: div_name,
          result: [],
          view: [],
          user: [],
        };
      }
      temp[div_code].result[score.month] = {
        new_actual: score.new_actual,
        new_target: score.new_target,
        ap_actual: score.ap_actual,
        ap_target: score.ap_target,
        app_result: score.app_result,
        app_target: score.app_target,
        contract_record: score.contract_record,
        contract_target: score.contract_target
      };
    });

    //全事業部の合算
    /*
    temp.forEach(divi => {
      console.log('*********', Object.assign({}, divi));
      divi.result.forEach(function (item, index) {
        if (!all_temp.result[index]) {
          all_temp.result[index] = {
            new_actual: 0,
            new_target: 0,
            ap_actual: 0,
            ap_target: 0,
            app_result: 0,
            app_target: 0,
            contract_record: 0,
            contract_target: 0
          }
        }
        all_temp.result[index].new_actual += item.new_actual;
        all_temp.result[index].new_target += item.new_target;
        all_temp.result[index].ap_actual += item.ap_actual;
        all_temp.result[index].ap_target += item.ap_target;
        all_temp.result[index].app_result += item.app_result;
        all_temp.result[index].app_target += item.app_target;
        all_temp.result[index].contract_record += item.contract_record;
        all_temp.result[index].contract_target += item.contract_target;
      });
    });
    temp.unshift(all_temp);
    */

    //不要データの削除
    // temp = temp.filter(n => n != null);

    /*
    temp.forEach(item => {
      item.result = item.result.filter(n => n != null);
    });
    console.log('********* CC', Object.assign({}, temp));
    */
    this.divilist = temp;
  }

  //ユーザー別リスト
  createUserList(result) {
    let temp = [];

    result.forEach(score => {
      //ユーザーの項目新規作成
      if (!temp[score.user_code]) {
        temp[score.user_code] = {
          code: score.user_code,
          division: score.division_code,
          name: (score.user_family_name?score.user_family_name:'') + (score.user_name?score.user_name:''),
          result: [],
          view: []
        };
      }
      //月ごとの予実格納
      temp[score.user_code].result[score.month] = {
        new_actual: score.new_actual,
        new_target: score.new_target,
        ap_actual: score.ap_actual,
        ap_target: score.ap_target,
        app_result: score.app_result,
        app_target: score.app_target,
        contract_record: score.contract_record,
        contract_target: score.contract_target
      };
    });

    //不要データの削除
    /*
    temp = temp.filter(n => n != null);
    temp.forEach(item => {
      item.result = item.result.filter(n => n != null);
    })
    */
    this.DivisionUserList(temp);
  }


  //事業部ごとにユーザーを分ける
  DivisionUserList(list) {
    this.divilist.forEach(divi => {
      if (divi.code != null) {
        let users = list.filter((user => user.division == divi.code));
        divi.user = users;
        this.divilist[0].user.push({
          code: divi.code,
          name: divi.name,
          result: divi.result,
          view: []
        });
      }
    });
    this.SearchRecord();
  }



  //未来のチェックボックスをクリック不可に
  ListHide() {
    this.months.forEach(item => {
      var y = this.year;
      if (item.month < 7) y++;
      let sel = new Date(y, item.month);
      let now = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
      if (now < sel) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
  }

  //年間チェック
  allYearCheck() {
    if (this.all_year) {
      this.months.forEach(month => {
        month.view = true;
      });
    } else if (!this.all_year) {
      this.months.forEach(month => {
        if (month.month == new Date().getMonth() + 1) {
          month.view = true;
        } else {
          month.view = false;
        }
      });
    }
    this.SearchRecord();
  }

  //モーダル
  open(content) {
    this.output_year = this.year;
    this.output_month = new Date().getMonth() + 1;
    this.modalService.open(content).result.then((result) => { }, (reason) => { });
  }

  //Excel出力
  output() {
    var date = this.output_year + '-' + this.output_month;
    let res = this.outputService.goal(date, this.view, this.divilist)
    res.subscribe(res => {
      const url = this.srcurl + "output/goal/予実_" + date + ".xlsx";
      window.open(url);
    });
  }

}
